import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { AudiomatchjobsListDataSource } from './audiomatchjobs-list-datasource'
import { RetrieveService } from '../api/services/retrieve.service';
import { TaskStatus } from '../api/models/task-status';
import { debounceTime, distinctUntilChanged, finalize } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { Router, ActivatedRoute, RouterLinkWithHref } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { AudioMatchJob } from '../api/models/audio-match-job';

export interface SearchParams {
  id?: string,
  run_id?: string,
  status?: TaskStatus;
  limit?: number;
  offset?: number;
  sort?: 'inserted' | 'last_update';
  order?: 'asc' | 'desc';
}

interface TaskStatusView {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-audiomatchjobs-list',
  templateUrl: './audiomatchjobs-list.component.html',
  styleUrls: ['./audiomatchjobs-list.component.css']
})
export class AudiomatchjobsListComponent implements OnInit, AfterViewInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<AudioMatchJob>;

  /* Task status */
  taskStatuses: TaskStatusView[] = [
    { value: 'none', viewValue: 'Empty' },
    { value: 'requested', viewValue: 'Requested' },
    { value: 'completed', viewValue: 'Completed' },
    { value: 'error', viewValue: 'Error' }
  ];

  /* Pagination */
  pageIndex: number;
  pageSize: number;

  /* Sorting */
  sortActive: string;
  sortDirection: 'asc' | 'desc';

  /** query parameters */
  searchParams: SearchParams = {
  };

  /** Table data source */
  dataSource: AudiomatchjobsListDataSource;

  /**  Filters */
  idFilter = new FormControl();
  runIdFiter = new FormControl();
  statusFilter = new FormControl();

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = ['job_id', 'run_id', 'status', 'elapsed', 'last_update', 'inserted', 'job_contents'];

  constructor(
    private retrieve: RetrieveService,
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog
  ) {
  };

  ngOnInit() {

    this.dataSource = new AudiomatchjobsListDataSource(this.retrieve);

    /* Read query parameters from URL */
    this.route.queryParams.subscribe(params => {
      this.idFilter.setValue(params['id'], { emitEvent: false });
      this.runIdFiter.setValue(params['runId'], { emitEvent: false });
      this.statusFilter.setValue(params['status'], { emitEvent: false });
      this.pageIndex = Number(params['pageIndex']) || 0;
      this.pageSize = Number(params['pageSize']) || 10;
      this.sortDirection = params['sortDirection'] || 'desc';
      this.sortActive = params['sortActive'] || 'last_update';
      this.loadAudiomatchJobsPage();
    });
  }

  ngAfterViewInit() {

    this.idFilter.valueChanges.pipe(
      debounceTime(150),
      distinctUntilChanged(),
    ).subscribe(value => {
      this.router.navigate(['audiomatchjobs/'], {
        queryParams: {
          id: value,
          pageIndex: 0
        },
        queryParamsHandling: 'merge'
      });
    });

    this.runIdFiter.valueChanges.pipe(
      debounceTime(150),
      distinctUntilChanged(),
    ).subscribe(value => {
      this.router.navigate(['audiomatchjobs/'], {
        queryParams: {
          runId: value,
          pageIndex: 0
        },
        queryParamsHandling: 'merge'
      });
    });


    this.statusFilter.valueChanges.pipe(
      debounceTime(150),
      distinctUntilChanged(),
    ).subscribe(value => {
      this.router.navigate(['audiomatchjobs/'], {
        queryParams: {
          status: value,
          pageIndex: 0
        },
        queryParamsHandling: 'merge'
      });
    });


    this.sort.sortChange
      .subscribe(() => {
        this.router.navigate(['audiomatchjobs/'], {
          queryParams: {
            sortDirection: this.sort.direction,
            sortActive: this.sort.active,
            pageIndex: 0,
          },
          queryParamsHandling: 'merge'
        });
      });

    this.paginator.page
      .subscribe(() => {
        this.router.navigate(['audiomatchjobs/'], {
          queryParams: {
            pageIndex: this.paginator.pageIndex,
            pageSize: this.paginator.pageSize
          },
          queryParamsHandling: 'merge'
        });
      });
  }

  loadAudiomatchJobsPage(): void {
    /**
     * Load a page of onpremise servers based on current parameters
     */

    /* Pagination */
    this.searchParams['offset'] = this.pageIndex * this.pageSize;
    this.searchParams['limit'] = this.pageSize;

    /* Sorting */
    this.searchParams['order'] = this.sortDirection;
    this.searchParams['sort'] = this.sortActive as 'inserted' | 'last_update';


    /* Filters */
    this.searchParams['id'] = this.idFilter.value ? this.idFilter.value: null;
    this.searchParams['run_id'] = this.runIdFiter.value ? this.runIdFiter.value: null;
    this.searchParams['status'] = this.statusFilter.value ? this.statusFilter.value: null;
    
    /* Run */
    this.dataSource.loadAudiomatchJobs(this.searchParams);
  }

  getStatusToolTip(row: AudioMatchJob): string {

    if (row.status != 'error'){
      return row.status
    }else{
      return 'Error: ' + row.meta['message']
    }

  }

}
